import {
  ActiveUser,
  AuthenticationContext,
  UserOffice,
} from "@/type/core/auth/auth.types";
import { OptionType } from "@/type/core/form/field.types";
import i18n from "i18next";
import { OfficeDetailsResponseDto } from "@state/offices/dto/response/office.details.response.dto";

const getOfficesOptions = (
  cabinets: OfficeDetailsResponseDto[] = [],
  defaultValue?: boolean,
): OptionType[] => {
  const result = cabinets
    .filter((office: OfficeDetailsResponseDto): boolean => office.cgu)
    .map((office: OfficeDetailsResponseDto) => ({
      label: office.alias || office.name,
      value: office.id,
    }));

  if (defaultValue) {
    result.unshift({
      label: i18n.t("ecfForm.accordion.provider.fields.officeId.placeholder"),
      value: "-1",
    });
  }

  return result;
};

const getAccessibleOffices = (user?: ActiveUser): UserOffice[] => {
  if (!user) {
    return [];
  } else if (user.offices && user.offices.length > 0) {
    return user.offices;
  } else if (user.officesForCgu && user.officesForCgu.length > 0) {
    return user.officesForCgu;
  } else {
    return [];
  }
};

const getSelectedOfficesFromStore = (
  authContext?: AuthenticationContext | null,
): UserOffice[] => {
  return getSelectedOffices(authContext?.user, authContext?.selectedOfficeIds);
};

const getSelectedOffices = (
  user?: ActiveUser,
  selectedOfficeIds: string[] = [],
): UserOffice[] => {
  return getAccessibleOffices(user).filter((office: UserOffice) =>
    selectedOfficeIds.includes(office.id),
  );
};

export const officeService = {
  getOfficesOptions,
  getAccessibleOffices,
  getSelectedOffices,
  getSelectedOfficesFromStore,
};
